import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './pages/Home';
import Store from './store';

Vue.use(VueRouter)

/* dynamic pages */
const Error404 = () => import('./pages/Error' /* webpackChunkName: 'err404' */);
const PersonalAplicacionGeneral = () => import('./pages/personal/Personal' /* webpackChunkName: 'personal' */);
const ActaVirtualSalas = () => import('./pages/aplicacion/ActaVirtualSalas' /* webpackChunkName: 'actaVirtualSalas' */);
const ArchivosAplicacion = () => import('./pages/Archivos' /* webpackChunkName: 'archivos' */);
const Postulante = () => import('./pages/postulante/Postulante' /* webpackChunkName: 'postulante' */);
const Evaluacion = () => import('./pages/evaluacion/Index' /* webpackChunkName: 'evaluacion' */);
const ResumenActaVirtual = () => import('./pages/aplicacion/ResumenActaVirtual' /* webpackChunkName: 'actaVirtual' */);
const PersonalAplicacionReemplazo = () => import('./pages/personal/reemplazo/Index' /* webpackChunkName: 'personalReemplazo' */);
const PersonalAplicacionAsistencia = () => import('./pages/personal/Asistencia' /* webpackChunkName: 'personalAsistencia' */);
const PersonalDeAplicacion = () => import('./pages/personal/Index' /* webpackChunkName: 'personalDeAplicacion' */);
const Psd = () => import('./pages/psd/Index' /* webpackChunkName: 'psd' */);
const ProblemasContratacion = () => import('./pages/personal/problemas-contratacion/Index' /* webpackChunkName: 'problemas-contratacion' */);
const ContratacionInclusion = () => import('./pages/personal/inclusion/Index' /* webpackChunkName: 'contratacion-inclusion' */);
const InformeJefeLocal = () => import('./pages/aplicacion/InformeJefeLocal.vue'  /* webpackChunkName: 'informeJefeLocal' */)
const InformeDelegado = () => import('./pages/info/InformeDelegado'  /* webpackChunkName: 'informeDelegado' */)

const routes = [
  {
    path: '/informacion',
    name: 'home',
    component: Home
  },
  {
    name: 'logout',
    path: '/logout',
    beforeEnter() {
      Store.dispatch('session/logout');
    }
  },
  {
    path: '/actaVirtualSalas',
    name: 'actaVirtualSalas',
    component: ActaVirtualSalas
  },
  {
    path: '/resumenActaVirtual',
    name: 'resumenActaVirtual',
    component: ResumenActaVirtual
  },
  {
    path: '/archivosAplicacion',
    name: 'archivosAplicacion',
    component: ArchivosAplicacion
  },
  {
    path: '/informe-jefe-local',
    name: 'informeJefeLocal',
    component: InformeJefeLocal
  },
  {
    path: '/informe-delegado',
    name: 'informeDelegado',
    component: InformeDelegado
  },
  {
    path: '/postulante',
    name: 'postulante',
    component: Postulante
  },
  {
    path: '*',
    name: 'error',
    component: Error404
  },
  {
    path: '/personal',
    name: 'personalDeAplicacion',
    component: PersonalDeAplicacion,
    children: [
    {
      path: 'general',
      name: 'personal',
      component: PersonalAplicacionGeneral
    }, {
      path: 'reemplazo',
      name: 'reemplazo',
      component: PersonalAplicacionReemplazo
    }, {
      path: 'asistencia',
      name: 'asistencia',
      component: PersonalAplicacionAsistencia,
      props: true,
    },
    {
      path: 'problemas-contratacion',
      name: 'problemasContratacion',
      component: ProblemasContratacion
    }, {
      path: 'contratacion-inclusion',
      name: 'contratacionInclusion',
      component: ContratacionInclusion,
    }
  ]
  },
  {
    path: '/evaluacion',
    name: 'evaluacion',
    component: Evaluacion
  },
  {
    path: '/psd',
    name: 'psd',
    component: Psd
  },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router;

